<template>
  <AppDialog
    v-if="visible"
    show
    title="Thanks for your interest!"
    append-to-body
    size="medium"
    position="centered"
    class="contractor-compliance-dialog"
    @close="handleClose"
  >
    <div class="content">
      <p class="description">
        We're working on this now but would love your feedback.
        Book a short call with us and we'll send you $50 as a thank you.
      </p>
    </div>

    <template #footer>
      <div class="ctas">
        <button
          class="btn btn-secondary"
          @click="closeDialog"
        >
          No thanks
        </button>
        <a
          href="https://zcal.co/i/Gn51vH5S"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-primary"
          @click="trackBookCall"
        >
          Book a call
        </a>
      </div>
    </template>
  </AppDialog>
</template>

<script>
export default {
  name: 'ContractorComplianceDialog',
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleClose() {
      this.trackClick('close');
      this.visible = false;
    },
    closeDialog() {
      this.trackClick('no_thanks');
      this.visible = false;
    },
    trackBookCall() {
      this.trackClick('book_a_call');
    },
    trackClick(ctaLabel) {
      window.analytics?.track('Clicked INOV001 Compliance Modal', {
        cta_label: ctaLabel,
        organization_id: this.organizationId,
      });
    },
  },
};
</script>
